import { render, staticRenderFns } from "./AgentsCommissionsSection.vue?vue&type=template&id=3707fff6&scoped=true"
import script from "./AgentsCommissionsSection.vue?vue&type=script&lang=js"
export * from "./AgentsCommissionsSection.vue?vue&type=script&lang=js"
import style0 from "./AgentsCommissionsSection.vue?vue&type=style&index=0&id=3707fff6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3707fff6",
  null
  
)

export default component.exports